export default "/public/dist/img/legenda.png";